<template>
  <div class="container-list" v-loading="loading">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        用户申请
      </div>
      <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
      </div>-->
    </div>
    <div class="common-page common-body">
      <!-- <div class="common-page common-tool-bar">
        <div class="btn" @click="showDia = true">
          <i class="icon-tr-search"></i>查询
        </div>
        <router-link class="btn ml20" to="/company/company-add">
          <i class="icon-tr-newly-added"></i>新增
        </router-link>
      </div> -->
      <div class="common-page common-list">
        <el-table :data="list" class="">
          <el-table-column
            prop="tr_login_account"
            label="登录账号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="tr_name"
            label="姓名"
            align="center"
          ></el-table-column>
          <el-table-column prop="tr_sex" align="center" label="性别">
            <template slot-scope="scope">
              {{ $map.sexStatus[scope.row.tr_sex] }}
            </template>
          </el-table-column>
          <el-table-column
            prop="tr_card"
            align="center"
            label="身份证号"
          ></el-table-column>
          <el-table-column
            prop="tr_unit"
            align="center"
            label="所属单位"
          ></el-table-column>
          <el-table-column
            prop="tr_unit_address"
            align="center"
            label="单位地址"
          ></el-table-column>
          <el-table-column prop="cname" align="center" label="操作">
            <template slot-scope="scope">
              <el-popconfirm
                title="确定通过此申请？"
                class="cursor"
                @onConfirm="passdown(scope.row.tr_user_uuid)"
                @confirm="passdown(scope.row.tr_user_uuid)"
              >
                <a slot="reference">
                  <el-button type="primary" size="mini">通过</el-button>
                </a>
              </el-popconfirm>

              <el-popconfirm
                title="确定拒绝此申请？"
                class="cursor"
                @onConfirm="passdown(scope.row.tr_user_uuid, 1)"
                @confirm="passdown(scope.row.tr_user_uuid, 1)"
              >
                <a slot="reference">
                  <el-button type="danger" size="mini">不通过</el-button>
                </a>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="pageChange"
        :page-size="10"
        :total="total"
      ></el-pagination>
    </div>
    <!-- <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
      <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm"></fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
        <el-button @click="showDia=false" size="small">取消</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import { getCompanyList, switchCompany } from "../../api/company";
export default {
  data() {
    return {
      list: [],
      // params: { page: 1,status:"",start_at:'',end_at:''},
      total: 0,
      showDia: false,
      loading: true,
      searchForm: this.$getForm("pinggusearch"),
      editData: {},
      remoteFuncs: {},
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      // getCompanyList(this.params)
      //   .then((res) => {
      //     // console.log(res);
      //     this.total = res.count;
      //     this.list = res.list;
      //   })
      //   .catch((err) => {});

      this.$post("/phpcontro/checklist").then((res) => {
        this.total = res.data.data.count;
        this.list = res.data.data;
        this.loading = false;
      });
    },
    passdown(tr_user_uuid, refused) {
      var tr_status = refused ? 0 : 1;
      var obj = { tr_user_uuid, tr_status };
      this.$post("/phpcontro/checkcanpass", obj).then((res) => {
        // this.$message.success("操作成功");
        this.$message({
									message: '操作成功',
									type: 'success',
									duration: 700,
								});
        this.getList();
      });
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          this.params.page = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { page: 1, limit: 10, ...this.$refs.searchForm.models };
      this.getList();
    },
  },
};
</script>

<style scoped>
</style>